import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    scroll-behavior: smooth;
  }

  body {
    font-family: ${theme.typography.fontBody};
    color: ${theme.colors.textPrimary};
    background-color: ${theme.colors.backgroundPrimary};
    line-height: 1.6;
    min-height: 100vh;
    overflow-x: hidden;
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  /* ── Global input styles (Cleave renders as <input>) ── */
  input {
    width: 100%;
    background: ${theme.colors.backgroundSecondary};
    border: 1.5px solid ${theme.colors.borderStrong};
    border-radius: ${theme.radius.md};
    padding: 13px 14px;
    color: ${theme.colors.textPrimary};
    font-family: ${theme.typography.fontMono};
    font-size: 16px;
    letter-spacing: 1px;
    transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
    -webkit-appearance: none;
    appearance: none;
    min-height: 44px;
  }

  input:focus {
    outline: none;
    border-color: ${theme.colors.borderFocus};
    box-shadow: ${theme.shadows.focus};
    background: ${theme.colors.surfaceCard};
  }

  input.invalid {
    border-color: ${theme.colors.dangerRed};
    background: ${theme.colors.dangerGlow};
  }

  input.invalid:focus {
    box-shadow: ${theme.shadows.danger};
  }

  input::placeholder {
    color: ${theme.colors.textMuted};
    letter-spacing: 0.3px;
    font-size: 14px;
  }

  /* Keyboard focus ring for non-input elements */
  :focus-visible {
    outline: 2px solid ${theme.colors.skyBlue};
    outline-offset: 2px;
  }

  /* Remove number input spinners */
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Buttons base reset */
  button {
    cursor: pointer;
    border: none;
    background: none;
    font-family: inherit;
  }
`;

export default GlobalStyle;
